/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createDataSharingGrantSummaryFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, type DataSharingGrantSummary, type ProblemDetails } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /customers/{customer-id}/data-sharing-grants
 */
export interface DataSharingGrantsRequestBuilder extends BaseRequestBuilder<DataSharingGrantsRequestBuilder> {
    /**
     * GetDataSharingGrantsByCustomer
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<DataSharingGrantSummary[]>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<DataSharingGrantSummary[] | undefined>;
    /**
     * GetDataSharingGrantsByCustomer
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const DataSharingGrantsRequestBuilderUriTemplate = "{+baseurl}/customers/{customer%2Did}/data-sharing-grants";
/**
 * Metadata for all the requests in the request builder.
 */
export const DataSharingGrantsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: DataSharingGrantsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createDataSharingGrantSummaryFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
